import React from "react";
import {Button, Card} from "react-bootstrap";

const DashboardPromotionCard = ({promotion, onOpen}) => {
    if (!promotion?.active) return null;

    const title = promotion.card_title || promotion.detail_title || "Special Promotion";
    const text = promotion.card_text || "Open the promotion details to learn more.";
    const buttonLabel = promotion.cta_label || "Learn more";

    return (
        <Card className="p-3 w-100 mt-2">
            <Card className="border-secondary">
                <Card.Header className="py-1">{title}</Card.Header>
                <Card.Body className="py-2">
                    <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2">
                        <div className="text-muted small">{text}</div>
                        <Button variant="success" size="sm" className="text-nowrap" onClick={onOpen}>
                            {buttonLabel}
                        </Button>
                    </div>
                </Card.Body>
            </Card>
        </Card>
    );
};

export default DashboardPromotionCard;
